import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';
import { useConnectorAccount } from './useConnectorAccount';
import '../Profile.css';

// Safe to link from an assistant: this page explains access without starting a payment.
export default function TalentConnectorAccessPage() {
  const { t, i18n } = useTranslation('profile');
  const { currentUser } = useAuth();
  const { data, loading } = useConnectorAccount(currentUser);
  const balance = data?.balance;
  const money = cents => new Intl.NumberFormat(i18n.language, { style: 'currency', currency: 'USD' }).format((cents || 0) / 100);

  return <main className="profile-page-container connector-approval-page" dir={i18n.dir()}>
    <section className="profile-panel connector-approval-card">
      <span className="connector-approval-icon" aria-hidden="true"><i className="fa-solid fa-circle-info" /></span>
      <h1>{t('connector.accessTitle')}</h1>
      <p>{t('connector.accessDescription')}</p>
      {loading && <p role="status" className="profile-muted-copy">{t('connector.loading')}</p>}
      {balance && <div className="connector-access-details">
        <p>{t('connector.accessFreeProfiles', { count: balance.free_profiles_remaining })}</p>
        <p>{t('connector.accessFreeContacts', { count: balance.free_contacts_remaining })}</p>
        {balance.mode === 'prepaid' && <p>{t('connector.accessPrepaid', { amount: money(balance.prepaid_cents) })}</p>}
        {balance.mode === 'postpaid' && <p>{t('connector.accessPostpaid', { amount: money(balance.amount_due_cents), limit: money(balance.unpaid_limit_cents) })}</p>}
      </div>}
      <p className="profile-muted-copy">{t('connector.accessUpdated')}</p>
    </section>
  </main>;
}
